import { ExtendedAxiosRequestConfig } from "@shared/services/api/abstracts/Repository";
import { useModelService } from "@shared/services/api/hooks/useModelService";
import PublicUserSMSRepository from "../repositories/PublicUserSMSRepository";

const usePublicUserSMS = () => {
  const repository = new PublicUserSMSRepository();

  const { useGenericMutation } = useModelService(repository);

  const useDeliverTickets = ({
    transaction_id,
    config,
  }: {
    transaction_id?: string;
    config?: ExtendedAxiosRequestConfig;
  }) => {
    return useGenericMutation<
      Promise<void>,
      {
        uuid1?: string;
        uuid2?: string;
        phone_number?: string | null;
      }
    >("deliverTickets", "POST", {
      injects: { transaction_id },
      config,
    });
  };

  return {
    useDeliverTickets,
  };
};

export default usePublicUserSMS;
